// frontend/src/pages/PortalRegister.jsx (Phase 19)
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { usePortalAuth } from "../context/PortalAuthContext";
import "../styles/portal.css";

export default function PortalRegister() {
  const { register } = usePortalAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [apiKey, setApiKey] = useState(null);
  const [copied, setCopied] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { ok, status, data } = await register(email.trim().toLowerCase(), password);
    setLoading(false);
    if (ok) {
      setApiKey(data.api_key);
      return;
    }
    if (status === 409) setError("Cet email est déjà utilisé.");
    else if (data?.code === "WEAK_PASSWORD") setError("Mot de passe : 8 caractères minimum.");
    else if (data?.code === "BAD_EMAIL") setError("Email invalide.");
    else setError("Échec de l'inscription. Réessaie.");
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  // Écran post-inscription : la clé n'est montrée qu'ICI, une seule fois.
  if (apiKey) {
    return (
      <div className="pt-root">
        <div className="pt-card">
          <h1 className="pt-title">Compte créé 🎉</h1>
          <p className="pt-subtitle">Voici ta clé API.</p>
          <div className="pt-keybanner">
            <div className="pt-keybanner__warn">
              ⚠️ Copie cette clé MAINTENANT — elle ne sera plus jamais affichée.
            </div>
            <div className="pt-keybox">
              <code>{apiKey}</code>
              <button className="pt-btn pt-btn--sm pt-btn--primary" onClick={copy}>
                {copied ? "Copié ✓" : "Copier"}
              </button>
            </div>
          </div>
          <button className="pt-btn pt-btn--primary" onClick={() => navigate("/portal/dashboard")}>
            Accéder au dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-root">
      <form className="pt-card" onSubmit={submit}>
        <h1 className="pt-title">Créer un compte</h1>
        <p className="pt-subtitle">Accède à l'Oracle d'Entropie en quelques secondes.</p>

        <label className="pt-label">Email</label>
        <input className="pt-input" type="email" value={email}
               onChange={(e) => setEmail(e.target.value)} required />

        <label className="pt-label">Mot de passe</label>
        <input className="pt-input" type="password" value={password}
               onChange={(e) => setPassword(e.target.value)} required minLength={8} />

        <div className="pt-error">{error}</div>
        <button className="pt-btn pt-btn--primary" disabled={loading}>
          {loading ? "Création…" : "Créer mon compte"}
        </button>
        <div className="pt-foot">
          Déjà un compte ? <Link className="pt-link" to="/portal/login">Se connecter</Link>
        </div>
      </form>
    </div>
  );
}
